import { saveProductList } from './products';

watchLocalStorageChange('cart', (newValue) => {
  if (newValue != null) {
    let totalCount = 0;
    let totaltAmount = 0;

    newValue = JSON.parse(newValue);
    for (let i = 0; i < newValue.length; i++) {
      totalCount += 1;
      totaltAmount += newValue[i].amount;
    }

    document.getElementById('cart__counter').textContent = `${totalCount}`;
    document.getElementById('cart__amount').textContent = `${Math.round(totaltAmount)}`;
  }
});

watchSessionStorageChange('product_list', (newValue) => {
  if (newValue == null) {
    saveProductList();
  }
});

function watchSessionStorageChange(key, callback) {
  let initialValue = sessionStorage.getItem(key);

  callback(initialValue);

  // Create an interval to periodically check for changes
  setInterval(() => {
    const storedValue = sessionStorage.getItem(key);

    if (storedValue !== initialValue) {
      // The value has changed, call the callback function
      callback(storedValue);
      initialValue = storedValue; // Update the initial value
    }
  }, 200); // Adjust the interval as needed
}

function watchLocalStorageChange(key, callback) {
  let initialValue = localStorage.getItem(key);
  if (initialValue == null) {
    localStorage.setItem('cart', JSON.stringify([]));
  }

  callback(initialValue);

  // Create an interval to periodically check for changes
  setInterval(() => {
    const storedValue = localStorage.getItem(key);

    if (storedValue !== initialValue) {
      // The value has changed, call the callback function
      callback(storedValue);
      initialValue = storedValue; // Update the initial value
    }
  }, 200); // Adjust the interval as needed
}

export function clearCart() {
  localStorage.setItem('cart', JSON.stringify([]));
}

export function checkoutCartUpdateQty(itemId, value) {
  if (!isNaN(parseFloat(value))) {
    const cart = JSON.parse(localStorage.getItem('cart'));
    const keyValueToFind = itemId.replace(/\s/g, '');
    const products = JSON.parse(sessionStorage.getItem('product_list'));
    let QtyPriceToUse = false;
    for (let j = 0; j < products.length; j++) {
      if (products[j].Itemcode == keyValueToFind) {
        if (products[j].QtyPrices?.QtyPrice) {
          let foundQtyPrice = false;
          if (!Array.isArray(products[j].QtyPrices.QtyPrice)) {
            products[j].QtyPrices.QtyPrice = [products[j].QtyPrices.QtyPrice];
          }
          for (let k = 0; k < products[j].QtyPrices.QtyPrice.length; k++) {
            if (value >= products[j].QtyPrices.QtyPrice[k].Qty) {
              QtyPriceToUse = products[j].QtyPrices.QtyPrice[k].Price;
              foundQtyPrice = true;
            }
          }
          if (!foundQtyPrice) {
            QtyPriceToUse = products[j].Price;
          }
        } else {
          QtyPriceToUse = products[j].Price;
        }
      }
    }

    const keyToFind = 'item';
    let totaltAmount = 0;
    for (let i = 0; i < cart.length; i++) {
      if (cart[i][keyToFind] == keyValueToFind) {
        cart[i].price = QtyPriceToUse;
        cart[i].qty = parseFloat(value);
        cart[i].amount = parseFloat(parseFloat(value) * cart[i].price);
        document.querySelector(`.cart-item-id[value="${keyValueToFind}"]`).closest('tr').querySelector('.item-price').textContent = `${parseFloat(cart[i].price)} kr`;
        document.querySelector(`.cart-item-id[value="${keyValueToFind}"]`).closest('tr').querySelector('.item-amount').textContent = `${parseFloat(cart[i].amount)} kr`;
      }
      totaltAmount += cart[i].amount;
    }
    localStorage.setItem('cart', JSON.stringify(cart));
    document.getElementById('cart-total-amount-container').textContent = `${parseFloat(Math.round(totaltAmount))}`;
  }
}

export function checkoutCartRemoveItem(itemId) {
  const cart = JSON.parse(localStorage.getItem('cart'));
  const keyValueToFind = itemId.replace(/\s/g, '');
  const keyToFind = 'item';
  let totaltAmount = 0;
  for (let i = 0; i < cart.length; i++) {
    if (cart[i][keyToFind] == keyValueToFind) {
      cart.splice(i, 1);
    }
  }
  for (let i = 0; i < cart.length; i++) {
    totaltAmount += cart[i].amount;
  }
  localStorage.setItem('cart', JSON.stringify(cart));
  document.getElementById('cart-total-amount-container').textContent = `${parseFloat(Math.round(totaltAmount))}`;
}

export function getUserInformation(value) {
  if (localStorage.getItem('wlUserInformation')) {
    const savedUserInformation = JSON.parse(localStorage.getItem('wlUserInformation'));
    if (savedUserInformation[value]) {
      return savedUserInformation[value];
    }
  }
  return false;
}
